<div class="ds-checkbox">
  <input #inputCheckbox
         (click)="onClick()"
         [(ngModel)]="checked"
         [disabled]="disabled"
         [id]="id"
         [name]="name"
         ngModel
         type="checkbox">
  <label [for]="id">
    <em class="ds-icon ds-icon--checked ds-checkbox-check-mark"></em>
    <ng-content></ng-content>
  </label>
  <ds-input-error [error]="error" [showError]="showError"></ds-input-error>
</div>
